import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialCabotageOperationPageState,
  CabotageOperationItemData,
  CabotageOperationListResponse,
  CabotageOperationListStateType,
} from "../core/_model.cabotage-operation";

export type ActionedCabotageOperation = {
  data: CabotageOperationItemData | null;
  action: ActionsKey;
};

type CabotageOperationDataType = {
  cabotageOperationList: any;
  detail: CabotageOperationItemData | null;
  actioned: ActionedCabotageOperation | null;
  totalItems: number;
  setDetail: (detail: CabotageOperationItemData | null) => void;
  setCabotageOperationList: (roles: CabotageOperationListResponse | null) => void;
  setActioned: (act: ActionedCabotageOperation | null) => void;
};

export const useCabotageOperationStore = create<CabotageOperationDataType>((set) => ({
  cabotageOperationList: [],
  detail: null,
  actioned: null,
  totalItems: 0,
  setDetail: (detail) => set((state) => ({ detail })),
  setCabotageOperationList: (cabotageOperationData) =>
    set((state) => ({
      cabotageOperationList: cabotageOperationData?.member,
      totalItems: cabotageOperationData?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));

export const useCabotageOperationListState = create<CabotageOperationListStateType>(
  (set) => ({
    pageState: initialCabotageOperationPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
  })
);
